// extracted by mini-css-extract-plugin
module.exports = {"editor":"EditorTextoLivre_editor__2Y8w_"};